export const FETCH_TAXONOMY_REQUEST = "FETCH_TAXONOMY_REQUEST";
export const FETCH_TAXONOMY_SUCCESS = "FETCH_TAXONOMY_SUCCESS";
export const FETCH_TAXONOMY_FAILURE = "FETCH_TAXONOMY_FAILURE";